import React from "react"
import { ApplicationAddress } from "../types/applicationData"
import VideoUploader, { VideoProgressItem } from "../components/VideoUploader"
import ImageUploader, { ImageProgressItem } from "../components/ImageUploader"

const isVideoUrl = (url: string) => {
  return /\.(mp4|mov|m4v|webm)(\?|#|$)/i.test(url)
}

export const generateAvailableStates = (
  state: string,
  barter: boolean,
  setAvailableStates: (states: string[]) => void,
) => {
  switch (state) {
    case "invite_new":
      setAvailableStates(["invite_success", "brand_canceled", "user_canceled"])
      break
    case "invite_success":
      if (barter === true) {
        setAvailableStates(["waiting_address", "brand_canceled", "user_canceled"])
      } else if (barter === false) {
        setAvailableStates(["waiting_content", "brand_canceled", "user_canceled"])
      }
      break
    case "ugc_content":
      setAvailableStates(["application_done", "ugc_rejected", "brand_canceled", "user_canceled"])
      break
    case "ugc_rejected":
      setAvailableStates(["ugc_content", "brand_canceled", "user_canceled"])
      break
    case "first_application":
      if (barter === true) {
        setAvailableStates(["waiting_address", "account_rejected", "user_canceled"])
      } else if (barter === false) {
        setAvailableStates(["waiting_content", "account_rejected", "user_canceled"])
      }
      break
    case "waiting_address":
      setAvailableStates(["address_to_approve", "brand_canceled"])
      break
    case "address_to_approve":
      setAvailableStates(["waiting_address", "waiting_content", "address_rejected"])
      break
    case "address_rejected":
      setAvailableStates(["waiting_address", "address_to_approve"])
      break
    case "waiting_content":
      setAvailableStates([
        "ugc_content",
        "content_to_share",
        "brand_canceled",
        "user_canceled",
        "application_timeout",
      ])
      break
    case "content_to_share":
      setAvailableStates([
        "content_approved",
        "content_rejected",
        "application_done",
        "brand_canceled",
      ])
      break
    case "content_approved":
      setAvailableStates(["content_shared", "user_canceled"])
      break
    case "content_shared":
      setAvailableStates(["application_done", "brand_canceled"])
      break
    case "content_rejected":
      setAvailableStates(["content_to_share", "brand_canceled", "user_canceled"])
      break
    case "brand_canceled":
      setAvailableStates([])
      break
    case "user_canceled":
      setAvailableStates([])
      break
    default:
      setAvailableStates([""])
  }
}

export const generateStatePayloads = (
  state: string,
  setStatePayloadTypes: (types: string[]) => void,
) => {
  switch (state) {
    case "ugc_rejected":
      setStatePayloadTypes(["review"])
      break
    case "ugc_content":
      setStatePayloadTypes(["img"])
      break
    case "content_to_share":
      setStatePayloadTypes(["img"])
      break
    case "content_shared":
      setStatePayloadTypes(["img"])
      break
    case "content_rejected":
      setStatePayloadTypes(["review"])
      break
    default:
      setStatePayloadTypes([""])
  }
}

export const handleStatePayload = (
  selectedStatePayloads: string,
  newState: string,
  newStatePayload: string,
  user_id: string,
  setUser_id: (id: string) => void,
  setNewStatePayload: (payload: string) => void,
  handleSelectPhotoFromPC: (type: string) => void,
  setSelectedSocialMedia: (media: string) => void,
  selectedSocialMedia: string,
  view: string,
  setView: (view: string) => void,
  reelsLikes: string,
  setReelsLikes: (likes: string) => void,
  reelsComments: string,
  setReelsComments: (comments: string) => void,
  reelsInteractions: string,
  setReelsInteractions: (interactions: string) => void,
  reelsSavings: string,
  setReelsSavings: (savings: string) => void,
  reelsSharings: string,
  setReelsSharings: (sharings: string) => void,
  address: ApplicationAddress,
  setAddress: (address: ApplicationAddress) => void,
  videoProgressItems?: VideoProgressItem[],
  setVideoProgressItems?: (items: VideoProgressItem[]) => void,
  imageProgressItems?: ImageProgressItem[],
  setImageProgressItems?: (items: ImageProgressItem[]) => void,
) => {
  switch (selectedStatePayloads) {
    case "link":
      return (
        <div>
          <span className="text-gray-700">Kullanıcı ID</span>
          <input
            type="string"
            className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            value={user_id}
            onChange={(e) => {
              setUser_id(e.target.value)
            }}
          />
          <span className="text-gray-700">Medya Url</span>
          <input
            type="url"
            className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            value={newStatePayload}
            onChange={(e) => {
              setNewStatePayload(e.target.value)
            }}
          />
        </div>
      )
    case "review":
      return (
        <div>
          <span className="text-gray-700">Gözden Geçir</span>
          <input
            type="string"
            className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            value={newStatePayload}
            onChange={(e) => {
              setNewStatePayload(e.target.value)
            }}
          />
        </div>
      )
    case "img": {
      const preExistingVideos =
        newStatePayload && isVideoUrl(newStatePayload) ? [newStatePayload] : []
      const combinedProgressItems = [
        ...(imageProgressItems || []),
        ...(videoProgressItems || []),
      ]
      return (
        <div>
          <div>
            <span className="text-gray-700">Resim/Video Url</span>
            <div className="flex flex-col gap-3 mb-2">
              <input
                type="string"
                className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                value={newStatePayload}
                onChange={(e) => {
                  setNewStatePayload(e.target.value)
                }}
              />
              <div className="flex items-center gap-2">
                <ImageUploader
                  preExistingImages={newStatePayload ? [newStatePayload] : []}
                  buttonLabel="Resim Seç"
                  showPreviews={false}
                  showInlineProgress={false}
                  onProgressItemsChange={(items) => {
                    setImageProgressItems?.(items)
                  }}
                  onUploadComplete={(urls) => {
                    setNewStatePayload(urls[0] || "")
                  }}
                />
                <VideoUploader
                  preExistingVideos={preExistingVideos}
                  buttonLabel="Video Seç"
                  showPreviews={false}
                  showInlineProgress={false}
                  onProgressItemsChange={(items) => {
                    setVideoProgressItems?.(items)
                  }}
                  onUploadComplete={(urls) => {
                    setNewStatePayload(urls[0] || "")
                  }}
                />
              </div>
              {combinedProgressItems.some((item) => item.isUploading || item.error) && (
                <div className="flex flex-col gap-2 w-full">
                  {combinedProgressItems.map((item, index) =>
                    item.isUploading || item.error ? (
                      <div
                        key={`${item.fileName}-${index}`}
                        className="w-full overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm"
                      >
                        <div className="px-3 py-2">
                          <div className="flex items-center justify-between text-xs text-gray-600 mb-1">
                            <span className="truncate">{item.fileName}</span>
                            {item.isUploading && (
                              <span className="inline-flex items-center rounded-full bg-blue-50 px-2 py-0.5 text-[11px] font-semibold text-blue-700">
                                {item.progress}%
                              </span>
                            )}
                          </div>
                          {item.error && <span className="text-red-500 text-xs">{item.error}</span>}
                        </div>
                        {!item.error && (
                          <div className="w-full bg-gray-100 h-2">
                            <div
                              className="bg-gradient-to-r from-blue-500 to-indigo-500 h-2 transition-all duration-200"
                              style={{ width: `${item.progress}%` }}
                            ></div>
                          </div>
                        )}
                      </div>
                    ) : null,
                  )}
                </div>
              )}
            </div>
            {newState === "application_done" && (
              <div>
                <div>
                  <label className="block">
                    <span className="text-gray-700">Sosyal Medya Türü Seç</span>
                    <select
                      className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 mb-4 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      onChange={(e) => setSelectedSocialMedia(e.target.value)}
                    >
                      <option value="">Sosyal Medya Türü Seç</option>
                      <option value={"instagram"}>Instagram</option>
                      <option value={"tiktok"}>TikTok</option>
                    </select>
                  </label>
                </div>
                {selectedSocialMedia === "tiktok" && (
                  <div>
                    <span className="text-gray-700">
                      Resim İzlenme Sayısı <span className="text-xl text-red-400">*</span>
                    </span>
                    <input
                      type="string"
                      className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      value={view}
                      onChange={(e) => {
                        setView(e.target.value)
                      }}
                    />
                  </div>
                )}
                {selectedSocialMedia === "instagram" && (
                  <div>
                    <span className="text-gray-700">
                      Resim İzlenme Sayısı <span className="text-xl text-red-400">*</span>
                    </span>
                    <input
                      type="string"
                      className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      value={view}
                      onChange={(e) => {
                        setView(e.target.value)
                      }}
                    />
                    <span className="text-gray-700">
                      Resim Reels beğenileri <span className="text-xl text-red-400">*</span>
                    </span>
                    <input
                      type="string"
                      className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      value={reelsLikes}
                      onChange={(e) => {
                        setReelsLikes(e.target.value)
                      }}
                    />
                    <span className="text-gray-700">
                      Resim Reels Yorumları <span className="text-xl text-red-400">*</span>
                    </span>
                    <input
                      type="string"
                      className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      value={reelsComments}
                      onChange={(e) => {
                        setReelsComments(e.target.value)
                      }}
                    />
                    <span className="text-gray-700">
                      Resim Reels Etkileşimleri <span className="text-xl text-red-400">*</span>
                    </span>
                    <input
                      type="string"
                      className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      value={reelsInteractions}
                      onChange={(e) => {
                        setReelsInteractions(e.target.value)
                      }}
                    />
                    <span className="text-gray-700">
                      Resim Reels Kaydetmeleri <span className="text-xl text-red-400">*</span>
                    </span>
                    <input
                      type="string"
                      className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      value={reelsSavings}
                      onChange={(e) => {
                        setReelsSavings(e.target.value)
                      }}
                    />
                    <span className="text-gray-700">
                      Resim Reels Paylaşımları <span className="text-xl text-red-400">*</span>
                    </span>
                    <input
                      type="string"
                      className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      value={reelsSharings}
                      onChange={(e) => {
                        setReelsSharings(e.target.value)
                      }}
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )
    }
    case "address":
      return (
        <div>
          <span className="text-gray-700">
            Contact Name <span className="text-xxs text-red-500">*required</span>
          </span>
          <input
            type="string"
            className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            placeholder="John Doe"
            value={address.contactName}
            onChange={(e) => {
              setAddress({ ...address, contactName: e.target.value })
            }}
          />
          <span className="text-gray-700">Contact Phone</span>
          <input
            type="string"
            className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            placeholder="905554441212"
            value={address.contactPhone}
            onChange={(e) => {
              setAddress({ ...address, contactPhone: e.target.value })
            }}
          />
          <span className="text-gray-700">
            City <span className="text-xxs text-red-500">*required</span>
          </span>
          <input
            type="string"
            className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            value={address.city}
            placeholder="Istanbul"
            onChange={(e) => {
              setAddress({ ...address, city: e.target.value })
            }}
          />
          <span className="text-gray-700">
            Country <span className="text-xxs text-red-500">*required</span>
          </span>
          <input
            type="string"
            className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            placeholder="Turkey"
            value={address.country}
            onChange={(e) => {
              setAddress({ ...address, country: e.target.value })
            }}
          />
          <span className="text-gray-700">
            Address <span className="text-xxs text-red-500">*required</span>
          </span>
          <input
            type="string"
            className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            value={address.address}
            onChange={(e) => {
              setAddress({ ...address, address: e.target.value })
            }}
          />
          <span className="text-gray-700">Details</span>
          <input
            type="string"
            className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            placeholder="Near the park"
            value={address.details}
            onChange={(e) => {
              setAddress({ ...address, details: e.target.value })
            }}
          />
          <span className="text-gray-700">Zip Code</span>
          <input
            type="string"
            className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            placeholder="34000"
            value={address.zipCode}
            onChange={(e) => {
              setAddress({ ...address, zipCode: e.target.value })
            }}
          />
          <span className="text-gray-700">Extra Information</span>
          <input
            type="string"
            className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            value={address.extra_information}
            onChange={(e) => {
              setAddress({ ...address, extra_information: e.target.value })
            }}
          />
        </div>
      )
  }
}
